
<app-off-canvas-form [id]="getOffCanvasIDForLevel(1)"></app-off-canvas-form>
<app-off-canvas-form [level]="2" [id]="getOffCanvasIDForLevel(2)"></app-off-canvas-form>
<app-off-canvas-form [level]="3" [id]="getOffCanvasIDForLevel(3)"></app-off-canvas-form>

<!-- 
<app-off-canvas-bottom-component [id]="getOffCanvasIDForLevel(1, offCanvasPlacement.Bottom)"></app-off-canvas-bottom-component>
<app-off-canvas-bottom-component [level]="2" [id]="getOffCanvasIDForLevel(2, offCanvasPlacement.Bottom)"></app-off-canvas-bottom-component>
<app-off-canvas-bottom-component [level]="3" [id]="getOffCanvasIDForLevel(3, offCanvasPlacement.Bottom)"></app-off-canvas-bottom-component> -->